import { PSClickWrap } from '@pactsafe/pactsafe-react-sdk';

interface PactSafeProps {
  userId?: string;
  onInvalid: () => void;
  onValid: () => void;
}

const PACTSAFE_ACCESS_ID = '1709e523-d2bc-4026-9436-37a2d1b6d419';
const PACTSAFE_GROUP_KEY = 'group-sjrtcg7xf';

export const PactSafe = ({ userId, onValid, onInvalid }: PactSafeProps) => {
  return (
    <div className="[&_.ps-contract]:!p-0 [&_.ps-contract-scroll]:!max-h-32">
      <PSClickWrap
        accessId={PACTSAFE_ACCESS_ID}
        groupKey={PACTSAFE_GROUP_KEY}
        signerId={userId}
        displayAll={false}
        testMode={!import.meta.env.PROD}
        clickWrapStyle={'scroll'}
        forceScroll
        onValid={onValid}
        onInvalid={onInvalid}
        allowDisagreed={false}
      />
    </div>
  );
};
